
interface BrowserSchemeParams {
    cache?: string;
    timeout?: string;
    topLeftBtnType?: string;
    bottomBar?: string;
    topbar?: string;
    title?: string;
    share?: boolean;
    type?: string;
    url: string;
    loadingStyle?: '0' | '1';
    enableLongpress?: 0 | 1;
    supportDark?: 0 | 1;
    rejectWindowOpen?: number;
    statistics?: object;
    source?: string;
    forceForbiddenSlide?: 0 | 1;
    fullScreenSlideClose?: 0 | 1;
    shareData?: Record<string, any>;
    pageType?: string;
    // eslint-disable-next-line
    d_args?: object;
    clickShareData?: object;
    enableCloseBtn?: 0 | 1;
}

/**
 * @description 拼接新浏览框架的schema=
 * @param url url链接
 * @param type 类型 页面的类型，full全屏，float半屏
 * @param share 是否显示分享
 * @param title 标题
 * @param enableLongpress 是否开启长按复制
 * @param rejectWindowOpen 是否禁止打开push新页面
 * @param bottomBar 是否隐藏bottombar栏0隐藏1不隐藏
 * @param loadingStyle 加载样式，0为默认中间loading，1为顶部进度条
 * @param forceForbiddenSlide 是否禁用中间右滑返回 0-不禁用；1-禁用
 * @param fullScreenSlideClose  是否禁用边缘返回 0-不禁用；1-禁用
 * @param shareData 分享数据
 * @param clickShareData 点击分享需要的打点数据
 * @returns schema 可以使用invokeSchema打开
 * https://es.baidu-int.com/index#/apidetail/2732 默认有顶bar,浏览器式，通常用于打开第三方落地页
 */
export const generateBrowseSchema = (obj: BrowserSchemeParams): string => {
    const {
        url,
        type = 'full',
        share = 'false',
        title = '',
        timeout,
        topLeftBtnType = 'close',
        enableLongpress = 1,
        bottomBar,
        supportDark,
        rejectWindowOpen,
        source,
        statistics,
        loadingStyle = '0',
        forceForbiddenSlide = 0,
        fullScreenSlideClose = 0,
        shareData,
        pageType,
        // eslint-disable-next-line
        d_args,
        clickShareData,
    } = obj;
    // baiduwanhua://newbrowse/open?params=%7B%22share%22%3Afalse%2C%22type%22%3A%22landing%22%2C%22url%22%3A%22http%3A%2F%2Fwww.baidu.com%22%7D&callback=__boxx_2
    const schema = `baiduwanhua://newbrowse/open?params=${encodeURIComponent(JSON.stringify({
        share,
        type,
        url,
        title,
        timeout,
        topLeftBtnType,
        enableLongpress,
        bottomBar,
        supportDark,
        rejectWindowOpen,
        source,
        statistics,
        loadingStyle,
        forceForbiddenSlide,
        fullScreenSlideClose,
        shareData,
        pageType,
        // eslint-disable-next-line
        d_args,
        clickShareData,
    }))}`;
    return schema;
};

/**
 * @description 拼接浏览框架的schema=
 * @param url url链接
 * @param type 类型 页面的类型，full全屏，float半屏
 * @param share 是否显示分享
 * @param title 标题
 * @param enableLongpress 是否开启长按复制
 * @param bottomBar 是否隐藏bottombar栏0隐藏1不隐藏
 * @returns schema 可以使用invokeSchema打开
 * https://es.baidu-int.com/index#/apidetail/2421  无顶bar,沉浸式，内部自建页（废弃，用openDetail端能力）
 */
export const generateBrowseDetailSchema = (obj: BrowserSchemeParams): string => {
    const {
        url,
        type = 'full',
        share = 'false',
        title = '',
        timeout,
        topLeftBtnType = 'close',
        enableLongpress = 1,
        bottomBar,
        enableCloseBtn = 1,
    } = obj;
    // baiduwanhua://newbrowse/detail?params=%7B%22share%22%3Afalse%2C%22type%22%3A%22landing%22%2C%22url%22%3A%22http%3A%2F%2Fwww.baidu.com%22%7D&callback=__boxx_2
    const schema = `baiduwanhua://newbrowse/detail?params=${encodeURIComponent(JSON.stringify({
        share,
        type,
        url,
        title,
        timeout,
        topLeftBtnType,
        enableLongpress,
        bottomBar,
        enableCloseBtn,
    }))}`;
    return schema;
};

/**
 * @description 输入schema直接调起，暂时需要自行确保schema正确，后续增加判断
 * @param schema 调起的schema
 */
export const invokeSchema = (schema: string) => {
    const iframe = document.createElement('iframe');
    iframe.src = schema;
    document.body.appendChild(iframe);
    document.body.removeChild(iframe);
};

export const openDetailBrowse = (obj: BrowserSchemeParams) => {
    invokeSchema(generateBrowseDetailSchema(obj));
};

export const openBrowse = (obj: BrowserSchemeParams) => {
    invokeSchema(generateBrowseSchema(obj));
};
